import { VehicleType } from "../../common/models/VehicleType";
import { VehicleTypeResponse } from "../models/responses/VehicleTypeResponse";

export const VehicleTypeMapper = (data: VehicleTypeResponse): VehicleType => {
  return {
    id: data._id,
    energySource: data.energySource,
    name: data.name,
    passengers: data.passengers,
    photo: data.photo,
    available: data.available
  }
}